var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTakingNewClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "45px",
    viewBox: "0 0 32 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7F73F6A1-D570-4011-9051-96C0B45B0EB3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q-T-P8-S4",
    transform: "translate(-541.000000, -240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(420.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle",
    transform: "translate(87.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-takingNewClients",
    transform: "translate(34.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7812339,0 L5.62502146,0 C2.52377513,0 0,2.52376559 0,5.625 L0,30.4554749 C0,31.490593 0.839770616,32.3307038 1.87489269,32.3307038 C2.91001477,32.3307038 3.74978538,31.490593 3.74978538,30.4554749 L3.74978538,5.625 C3.74978538,4.59194186 4.59161599,3.75011446 5.62502146,3.75011446 L18.9319973,3.75011446 L18.3600194,3.94134521 C16.8414971,4.46628568 15.8214813,5.89691162 15.8214813,7.49988554 L15.8214813,35.6248855 L5.62502146,35.6248855 C4.59161599,35.6248855 3.74978538,34.7830581 3.74978538,33.75 L3.74978538,29.9998855 C3.74978538,28.9651108 2.91001477,28.125 1.87489269,28.125 C0.839770616,28.125 0,28.9651108 0,29.9998855 L0,33.75 C0,36.8512344 2.52377513,39.375 5.62502146,39.375 L15.8214813,39.375 L15.8214813,41.2498855 C15.8214813,43.3180618 17.5030825,45 19.5712667,45 C19.9726126,45 20.3533589,44.9419785 20.7656911,44.8142624 L29.4594019,41.0586548 C30.9799842,40.5337143 32,39.1030884 32,37.5001145 L32,3.75011446 C32,1.56383517 30.1154942,-0.150032021 27.9161602,0.0281524219 C27.8694682,0.0243759375 27.829986,0 27.7812339,0 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#1EE0A6",
    cx: 21.2857879,
    cy: 23.1428571,
    rx: 2.57143838,
    ry: 2.57142857
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTakingNewClients);
export default __webpack_public_path__ + "static/media/icon-takingNewClients.9e6ace94bf5b9e5502076c6840ad9114.svg";
export { ForwardRef as ReactComponent };